export enum SupportPermissions {
  ALL = "Travel:Support:*",
  READ = "Travel:Support:Read",
  WRITE = "Travel:Support:Write",
}

export function hasSupportAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [SupportPermissions.READ, SupportPermissions.ALL, "*"].includes(p)
  );
}
